import Vue from "vue";

const state = {
	adminclients_options: {
		page: 1,
		itemsPerPage: null,
		sortBy: ["fullname"],
		sortDesc: [true],
		groupBy: [],
		groupDesc: [],
		mustSort: false,
		multiSort: false,
		search: null,
	},
	adminclients: {},
	_adminclients_loading: 0,
	showCreateEditAdminClients: false,
	currentAdminClients: {},
	_adminclients_exporting: 0,
	_adminclients_importing: 0,
	showImportAdminClients: false,
	readedAdminClientsImport: null,
	autocompleteadminclients: null,
	_autocompleteadminclients_loading: 0,
};

const getters = {
	getAdminClientsOptions: (state) => state.adminclients_options,
	getAdminClients: (state) => state.adminclients,
	adminclients_loading: (state) => state._adminclients_loading !== 0,
	showCreateEditAdminClients: (state) => state.showCreateEditAdminClients,
	getCurrentAdminClients: (state) => state.currentAdminClients,
	adminclients_exporting: (state) => state._adminclients_exporting !== 0,
	adminclients_importing: (state) => state._adminclients_importing !== 0,
	showImportAdminClients: (state) => state.showImportAdminClients,
	getReadedAdminClientsImport: (state) => state.readedAdminClientsImport,
	getAutocompleteAdminClients: (state) => state.autocompleteadminclients,
	autocompleteadminclients_loading: (state) => state._autocompleteadminclients_loading !== 0,
};

const actions = {
	fetchAdminClients({ commit, dispatch }) {
		commit("START_ADMINCLIENTS_LOADING");
		axios
			.get("/api/admin/clients", { params: state.adminclients_options })
			.then((res) => {
				commit("setAdminClients", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_ADMINCLIENTS_LOADING");
			});
	},
	createAdminClients({ commit, dispatch }) {
		commit("START_ADMINCLIENTS_LOADING");
		if (!state.currentAdminClients.id) {
			return new Promise((resolve, reject) => {
				axios
					.post("/api/admin/clients", state.currentAdminClients)
					.then((res) => {
						dispatch("handleResponseMessage", res.data);
						if (state.showCreateEditAdminClients) {
							dispatch("fetchAdminClients");
							dispatch("hideAction", "hideCreateEditAdminClients");
						}
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_ADMINCLIENTS_LOADING");
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				axios
					.put("/api/admin/clients/" + state.currentAdminClients.id, state.currentAdminClients)
					.then((res) => {
						if (res.data.object) {
							dispatch("fetchAdminClients");
							dispatch("hideAction", "hideCreateEditAdminClients");
						}
						dispatch("handleResponseMessage", res.data);
						resolve(res.data);
					})
					.catch((err) => {
						dispatch("handleError", err);
						reject(err);
					})
					.then(function () {
						commit("STOP_ADMINCLIENTS_LOADING");
					});
			});
		}
	},
	deleteAdminClients({ commit, dispatch }, array_ids) {
		commit("START_ADMINCLIENTS_LOADING");
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/clients/delete", { array_ids: array_ids })
				.then((res) => {
					dispatch("fetchAdminClients");
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMINCLIENTS_LOADING");
				});
		});
	},
	exportAdminClients({ commit, dispatch }, type) {
		commit("START_ADMINCLIENTS_EXPORTING");
		axios
			.post("/api/admin/clients/export-download", state.adminclients_options, { responseType: "arraybuffer" })
			.then((res) => {
				dispatch("downloadFromResponse", res);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_ADMINCLIENTS_EXPORTING");
			});
	},
	importAdminClientsRead({ commit, dispatch }, formData) {
		commit("START_ADMINCLIENTS_IMPORTING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/clients/import-read", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					if (res.data) {
						commit("setReadedAdminClientsImport", res.data);
					}
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMINCLIENTS_IMPORTING");
				});
		});
	},
	importAdminClientsStore({ commit, dispatch }, formData) {
		commit("START_ADMINCLIENTS_IMPORTING");
		const source = axios.CancelToken.source();
		commit("setSource", source);
		commit("setProgress", { total: 100, loaded: 0 });
		return new Promise((resolve, reject) => {
			axios
				.post("/api/admin/clients/import-store", formData, {
					cancelToken: source.token,
					onUploadProgress: (e) => {
						// updating progress indicator
						commit("setProgress", { total: e.total, loaded: e.loaded });
					},
				})
				.then((res) => {
					if (res.data) {
						dispatch("hideAction", "hideImportAdminClients");
						dispatch("fetchAdminClients");
					}
					dispatch("handleResponseMessage", res.data);
					resolve(res.data);
				})
				.catch((err) => {
					dispatch("handleError", err);
					reject(err);
				})
				.then(function () {
					commit("STOP_ADMINCLIENTS_IMPORTING");
				});
		});
	},
	fetchAutocompleteAdminClients({ commit, dispatch }) {
		commit("START_AUTOCOMPLETEADMINCLIENTS_LOADING");
		axios
			.get("/api/admin/clients/search", { params: { itemsPerPage: -1 } })
			.then((res) => {
				commit("setAutocompleteAdminClients", res.data);
			})
			.catch((err) => {
				dispatch("handleError", err);
			})
			.then(function () {
				commit("STOP_AUTOCOMPLETEADMINCLIENTS_LOADING");
			});
	},
};
const mutations = {
	setAdminClientsOptions(state, value) {
		Vue.set(state, "adminclients_options", value);
	},
	setAdminClients(state, data) {
		Vue.set(state, "adminclients", data);
	},
	START_ADMINCLIENTS_LOADING(state) {
		state._adminclients_loading++;
	},
	STOP_ADMINCLIENTS_LOADING(state) {
		state._adminclients_loading--;
	},
	showCreateEditAdminClients(state) {
		state.showCreateEditAdminClients = true;
	},
	hideCreateEditAdminClients(state) {
		state.showCreateEditAdminClients = false;
	},
	setCurrentAdminClients(state, value) {
		Vue.set(state, "currentAdminClients", value);
	},
	START_ADMINCLIENTS_EXPORTING(state) {
		state._adminclients_exporting++;
	},
	STOP_ADMINCLIENTS_EXPORTING(state) {
		state._adminclients_exporting--;
	},
	setReadedAdminClientsImport(state, value) {
		Vue.set(state, "readedAdminClientsImport", value);
	},
	START_ADMINCLIENTS_IMPORTING(state) {
		state._adminclients_importing++;
	},
	STOP_ADMINCLIENTS_IMPORTING(state) {
		state._adminclients_importing--;
	},
	showImportAdminClients(state) {
		state.showImportAdminClients = true;
	},
	hideImportAdminClients(state) {
		state.showImportAdminClients = false;
		Vue.set(state, "readedAdminClientsImport", null);
	},
	setAutocompleteAdminClients(state, data) {
		Vue.set(state, "autocompleteadminclients", data);
	},
	START_AUTOCOMPLETEADMINCLIENTS_LOADING(state) {
		state._autocompleteadminclients_loading++;
	},
	STOP_AUTOCOMPLETEADMINCLIENTS_LOADING(state) {
		state._autocompleteadminclients_loading--;
	},
};

export default {
	state,
	getters,
	actions,
	mutations,
};
